"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const email = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        resendConfirmationEmail: async (email) => {
            const endpoint = `${url}/${defaultVersion}/emails/resendConfirmation`;
            const result = await httpClient.post(endpoint, {
                auth: false,
                payload: { email },
            });
            return result.data;
        },
        isFakeEmail: async (email) => {
            const endpoint = `${url}/${defaultVersion}/emails/${email}/isFakeEmail`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
    };
};
exports.default = email;
